import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Global Options 狀態型別 */
export type GlobalOptionsState = Record<string, unknown>;

/** setOption action payload 型別 */
export interface SetOptionPayload {
  type: string;
  payload: unknown;
}

/**
 * Global Options Slice
 * 全域選項狀態管理
 */
export const globalOptionsSlice = createSlice({
  name: 'options',
  initialState: {} as GlobalOptionsState,
  reducers: {
    setOption(state, action: PayloadAction<SetOptionPayload>) {
      state[action.payload.type] = action.payload.payload;
    }
  }
});

export const { actions, reducer } = globalOptionsSlice;
export const { setOption } = actions;
export default reducer;
